export const availableMediaAssets = {
    asn: ['spaarpot.gif'],
    blg: [],
    reb: ['spaarpot.gif'],
    sns: ['spaarpot.gif'],
    generic: ['identiteitskaart.png', 'paspoort.png', 'pensioen-uitleg.png', 'rijbewijs.png', 'verblijfsvergunning.png']
};
